<template>
  <div>
    <el-dialog :visible.sync="showSetDomain">
      <el-form :model="dataSet">
        <el-form-item prop="cid" label="渠道号" style="text-align:left;"><el-input v-model="dataSet.cid" size="mini" style="width: 200px;"></el-input></el-form-item>
        <el-form-item>
          <el-button type="success" size="mini" @click="subDomain()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-button size="mini"  type="primary"  @click="showDiv()">添加</el-button>

    <el-table :data="list" v-loading="loading">
      <el-table-column prop="id" label="ID" />
      <el-table-column prop="type" label="类型" />
      <el-table-column prop="user_id" label="user_id" />
<!--      <el-table-column prop="ticket" label="ticket" />-->
      <el-table-column prop="time" label="时间" />
<!--      <el-table-column prop="md5" label="md5" />-->
      <el-table-column prop="additional" label="扩展" />
      <el-table-column prop="id" label="操作" width="180px">
        <template slot-scope="scope">
          <el-button type="info" size="mini" @click="handleUser(scope.row)">二维码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <page-bar :currentPageCount="list.length" @page-changed="loadData"></page-bar> -->
  </div>
</template>

<script>
    import request from "../../api/request";

    export default {
        name: "QrCodeChannelList",
        data() {
            return {
                loading: true,
                showSetDomain: false,
                list:[],
                dataSet:{
                    cid:''
                },
                filter: {},
            };
        },
        created() {
            this.loadData();
        },
        methods: {
            subDomain: function() {
//      console.log(this.dataSet.user_id);

                request.tools
                    .post("qr_code_channel_set", {
                        cid: this.dataSet.cid + "",
                    })
                    .then(() => {
                        this.$message.success("提交成功");
                    })
                    .finally(() => {
                        this.dataSet ={};
                        location.reload();
                    });
            },

            async loadData() {
                request.tools
                    .post("qr_code_get_list", {
                        filter: { type: [ 'invite_channel' ] },
                        range: [ 0, 1000 ],
                        sort: [{ field: "id", reverse: true }]
                    })
                    .then(r => {
                        this.list = r.data.list;
                        this.loading = false;
                    });
            },
            showDiv () {
                this.showSetDomain = true
            },

            handleUser: function(data) {
                window.open ("https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket="+data.ticket);
            }

        }
    };
</script>